import UpdatePanel from "./UpdatePanel";

export default UpdatePanel;
